angular.module('app.shared.dobSelectorService', [])
  .factory('app.shared.dobSelectorService', [
    function () {
      "use strict";

      return {
        new: function () {
          let today = moment();

          let months = [];
          for (let i = 0; i < 12; i++) {
            let month = today.month(i);
            months.push({
              label: month.format('MMMM'),
              value: i + 1
            });
          }

          let years = [];
          for (let i = today.year(); i >= today.year() - 100; i--) {
            years.push(i);
          }

          return {
            month: null,
            day: null,
            year: null,
            months: months,
            years: years,
            days: function () {
              let strDate = this.year + '-' + this.month,
                length = this.year && this.month ?
                  moment(strDate, "YYYY-MM").daysInMonth() :
                  31;
              return _.range(1, length + 1);
            },
            getDate: function () {
              if (this.year && this.month && this.day) {
                return moment(this.year + '-' + this.month + '-' + this.day, "YYYY-MM-DD");
              } else if (this.year && this.month && !this.day) {
                this.day = 1;
                return moment(this.year + '-' + this.month + '-' + this.day, "YYYY-MM-DD");
              }
            }
          };
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/dobSelectorService.js